import { Injectable } from '@angular/core';
import localeDe from '@angular/common/locales/de';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeNl from '@angular/common/locales/nl';
import localeNn from '@angular/common/locales/nn';
import localePt from '@angular/common/locales/pt';
import localeSv from '@angular/common/locales/sv';
import localePl from '@angular/common/locales/pl';
import { registerLocaleData } from '@angular/common';
import { Store } from '@ngrx/store';
import { ActionTypes } from '../store/actions/my-account.action';
import { MyAccountState } from '../store/state/my-account.state';

@Injectable({
    providedIn: 'root'
})
export class LocalizationUtil {

    locale: string;

    constructor(
        private store: Store<MyAccountState>
    ) {}

    init() {
        this.store.dispatch({type: ActionTypes.LoadProfile});
        this.store.select(state => state.profile).subscribe(userInfo => {
            const language: string = userInfo.language;
            if (language) {
                this.locale = this.setLocale(language.substring(0, 2).toLowerCase());
            }
        });
    }

    getLocaleLanguage(): string {
        return this.locale;
    }

    setLocale(locale: string): string {
    // localeId must be 'en' to correspond with build configuration parameter
        switch (locale) {
        case 'en':
            break; // set by default
        case 'de':
            registerLocaleData(localeDe, 'en');
            break;
        case 'es':
            registerLocaleData(localeEs, 'en');
            break;
        case 'fr':
            registerLocaleData(localeFr, 'en');
            break;
        case 'nl':
            registerLocaleData(localeNl, 'en');
            break;
        case 'no':
            registerLocaleData(localeNn, 'en');
            break;
        case 'pt':
            registerLocaleData(localePt, 'en');
            break;
        case 'pl':
            registerLocaleData(localePl, 'en');
            break;
        case 'sv':
            registerLocaleData(localeSv, 'en');
            break;
        default:
            console.error(`Locale ${locale} not supported`);
            locale = undefined;
        }

        return locale;
    }
}
